export default __webpack_public_path__ + "static/media/2.5d1b917a.png";